module.exports = __webpack_public_path__ + "img/powerflowsimulation.b1f12eef.png";